import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})export class ApplicationUpdateCheckerService {
  constructor(public updates: SwUpdate, public toaster: ToastrService, ) {

    if (updates.isEnabled) {
      interval(1000 * 60 * 15).subscribe(() => updates.checkForUpdate()
        .then(() => console.log('checking for updates')));
    }
  }

  public checkForUpdates(): void {
    this.updates.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
    ).subscribe(event => this.promptUser());
  }

  private promptUser(): void {

    // console.log('updating to new version');
    // if (confirm('A newer version is now available.click yes to update.'))
    //  this.updates.activateUpdate().then(() => document.location.reload());
    // alert('a new update has been found')
    this.toaster.info('New update available! Reload the app to see latest juicy changes.');


  }
}
